import proj4 from 'proj4';

export const transformGPS = (lon, lat) => {
    const fromProj = "+proj=longlat +datum=WGS84 +no_defs";
    const toProj = "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs";
    return proj4(fromProj, toProj, [lon, lat]);
};